var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._l((_vm.rects),function(r,i){return _c('g',{key:i},[_c('rect',{attrs:{"x":r.x,"y":r.y,"width":r.width,"height":r.height,"stroke":"black","fill":"transparent","stroke-width":"1"}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }